import { createSlice } from '@reduxjs/toolkit';
import { SiteState } from './types';
import { StoreStatus } from '../../core/types/common.types';
import { getSiteThunk } from './thunks';

// Initial State
export const initialState: SiteState = {
  errors: null,
  status: StoreStatus.IDLE,
  response: null,
};

// Slice
export const siteSlice = createSlice({
  name: 'site',
  initialState,
  reducers: {
    reset: () => ({
      ...initialState,
    }),
  },
  extraReducers: (builder) => {
    builder.addCase(getSiteThunk.pending.type, (state) => {
      state.status = StoreStatus.BUSY;
    });

    builder.addCase(getSiteThunk.fulfilled.type, (state, action: any) => {
      state.status = StoreStatus.IDLE;
      state.response = action.payload;
      state.errors = null;
    });

    builder.addCase(getSiteThunk.rejected.type, (state, { payload }: any) => {
      state.status = StoreStatus.ERROR;
      state.errors = payload;
      state.response = null;
    });
  },
});

// Action creators
export const { reset } = siteSlice.actions;
export * from './thunks';
export * from './selectors';
export * from './types';
export default siteSlice.reducer;
